import { useShowResponseStatus } from '@/shared';
import { useDeleteRemotePaymentMethodMutation } from '../store/remote-payment-methos-api';

import type { TRemotePaymentMethodDeleteParams } from '../store/types';

export const useDeleteRemoteMethod = () => {
  const [deleteRemoteMethod, { isLoading, isSuccess, isError }] = useDeleteRemotePaymentMethodMutation();

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const handleRemoteMethodDelete = async (params: TRemotePaymentMethodDeleteParams) => {
    await deleteRemoteMethod(params);
  };

  return {
    handleRemoteMethodDelete,
    deleteRemoteMethod,
    isLoading,
  };
};
